<template>
  <div>
    <div>
      <h2>{{ $t("checklist.form.Own") }}</h2>
      <success-fade-alert ref="alert" msg="Formulário exluido com sucesso" />
      <fade-alert-danger ref="danger" msg="Formulário não exluido" />
    </div>

    <div><own :moduleId="'0'"> </own></div>
  </div>
</template>

<script>
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";

export default {
  components: {
    FadeAlertDanger,
    SuccessFadeAlert,
    Own: () => import("@/components_rms/checklist/own/Own.vue"),
  },
  data: function () {
    return {};
  },
  computed: {},
  methods: {
    myProvider(ctx) {
      this.isBusy = true;
      return this.$apiChecklist
        .post("/form/own/", {
          currentPage: ctx.currentPage,
          perPage: ctx.perPage,
          formActive: ctx.filter.formActive,
          formName: ctx.filter.formName,
        })
        .then((response) => {
          const items = response.data.items;
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          return items;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
            this.tableRowCount = 0;
            return [];
          }
        });
    },
  },
};
</script>


